import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=3d54e195&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=3d54e195&prod&scoped=true&lang=css"
import style1 from "./HelpCenter.vue?vue&type=style&index=1&id=3d54e195&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54e195",
  null
  
)

export default component.exports